<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="editColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    components: {
      pageTemplate,
    },
    data() {
      return {
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: "",
              type: 'select',
              prop: 'memberCategoryId',
              data: [],
              url: api.member.category
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
          },
        ],
        // 表格信息配置
        tableOptions: {
          // showSelect: true,
          indexShow: true,//是否显示索引
          columns: [
            {label: '充值金额及以上', prop: 'rechargeAmount', width: '120', align: 'center'},
            {label: '赠送金额', prop: 'giveAmount', width: '120', align: 'center'},
            {label: '赠送积分', prop: 'giveIntegral', width: '120', align: 'center'},
            {label: '会员类别', prop: 'memberCategoryName', width: '120', align: 'center',},
            // {label: '创建人', prop: 'createBy', width: '120', align: 'center'},
            {label: '创建时间', prop: 'createDttm', width: '125', align: 'center'},
            {label: '备注', prop: 'remarks', width: '125', align: 'center'},
          ],
          url: api.member.rechargeScheme
        },
        // 添加字段
        addColumns: {
          labelWidth: '120px',
          span: 12,
          columns: [
            {
              label: '会员类别',
              type: 'select',
              prop: 'memberCategoryId',
              data: [],
              url: api.member.category,
              rule: [
                {required: true, message: '请输入赠送积分', pattern: this.$utils.reg.thanNum, trigger: 'blur'},
              ],
            },
            {
              label: '门店',
              type: 'select',
              prop: 'storeIds',
              multiple: true,
              isHasAll: true,
              data: [],
              hidden: this.$utils.getSysUser().storeId ? true : false,
              url: api.store.store,
              rule: [
                {required: true, message: '请选择门店', trigger: 'blur'},
              ],
            },
            {
              label: '充值金额及以上',
              type: 'input',
              prop: 'rechargeAmount',
              rule: [
                {required: true, message: '请输入充值金额', pattern: this.$utils.reg.thanNum, trigger: 'blur'},
              ],
              change: this.changeRechart
            },
            {
              label: '赠送金额',
              type: 'inputNumber',
              prop: 'giveAmount',
              defaultValue: 0.00,
              rule: [
                {required: true, message: '请输入赠送金额', pattern: this.$utils.reg.thanNum, trigger: 'blur'},
              ],
            },
            {
              label: '赠送积分',
              type: 'inputNumber',
              prop: 'giveIntegral',
              defaultValue: 0.00,
              min: 0,
              rule: [
                {required: true, message: '请输入赠送积分', pattern: this.$utils.reg.thanNum, trigger: 'blur'},
              ],
            },

            {
              label: '备注',
              type: 'textarea',
              prop: 'remarks',
              span: 22,
            },

          ], // 表单label
          url: api.member.rechargeScheme
        },
        editColumns: {
          labelWidth: '120px',
          span: 12,
          columns: [
            {
              label: '会员类别',
              type: 'select',
              prop: 'memberCategoryId',
              data: [],
              disabled:true,
              url: api.member.category,
              rule: [
                {required: true, message: '请输入赠送积分', pattern: this.$utils.reg.thanNum, trigger: 'blur'},
              ],
            },
            {
              label: '门店',
              type: 'select',
              prop: 'storeIds',
              multiple: true,
              isHasAll: true,
              disabled:true,
              data: [],
              hidden: this.$utils.getSysUser().storeId ? true : false,
              url: api.store.store,
              rule: [
                {required: true, message: '请选择门店', trigger: 'blur'},
              ],
            },
            {
              label: '充值金额及以上',
              type: 'input',
              prop: 'rechargeAmount',
              rule: [
                {required: true, message: '请输入充值金额', pattern: this.$utils.reg.thanNum, trigger: 'blur'},
              ],
              change: this.changeRechart
            },
            {
              label: '赠送金额',
              type: 'inputNumber',
              prop: 'giveAmount',
              defaultValue: 0.00,
              rule: [
                {required: true, message: '请输入赠送金额', pattern: this.$utils.reg.thanNum, trigger: 'blur'},
              ],
            },
            {
              label: '赠送积分',
              type: 'inputNumber',
              prop: 'giveIntegral',
              defaultValue: 0.00,
              min: 0,
              rule: [
                {required: true, message: '请输入赠送积分', pattern: this.$utils.reg.thanNum, trigger: 'blur'},
              ],
            },

            {
              label: '备注',
              type: 'textarea',
              prop: 'remarks',
              span: 22,
            },

          ], // 表单label
          url: api.member.rechargeScheme
        },
      };
    },
    created() {

    },
    methods: {
      // 充值金额验证
      changeRechart(val) {
        if (!val.memberCategoryId) {
          this.$message.warning('请先选择会员类别')
          val.rechargeAmount = ''
        } else {
          let vadainput = /^\d+(\.{0,1}\d+){0,1}$/;
          if (!vadainput.test(val.rechargeAmount)) {
            this.$message.warning('请输入合法有效金额')
            val.rechargeAmount = ''
          } else {
            if (val.id && undefined !== val.id) {
              this.$axios.fetchGet(api.member.rechargeScheme + '?id=' + val.id).then(data => {
                if (data.code === 200) {
                  if (!(data.data.rechargeAmount === val.rechargeAmount)) {
                    this.$axios.fetchPost(api.member.mbRechargeRule, {
                      rechargeAmount: val.rechargeAmount,
                      memberCategoryId: val.memberCategoryId
                    }).then(res => {
                      if (res.code === 200) {
                        if (res.data) {
                          this.$message.warning('此会员类别下已存在' + val.rechargeAmount + '元的储值方案');
                          val.rechargeAmount = ''
                        }
                      } else {
                        this.$message.error(res.code + res.errorMsg)
                      }
                    })
                  }
                } else {
                  this.$message.error(res.code + res.errorMsg)
                }
              })
            } else {
              this.$axios.fetchPost(api.member.mbRechargeRule, {
                rechargeAmount: val.rechargeAmount,
                memberCategoryId: val.memberCategoryId
              }).then(res => {
                if (res.code === 200) {
                  if (res.data) {
                    this.$message.warning('此会员类别下已存在' + val.rechargeAmount + '元的储值方案');
                    val.rechargeAmount = ''
                  }
                } else {
                  this.$message.error(res.code + res.errorMsg)
                }
              });
            }
          }
        }
      },
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/member/ecard/Plan.vue